import script from "./ManufacturingDateCheckMixin.vue?vue&type=script&lang=ts"
export * from "./ManufacturingDateCheckMixin.vue?vue&type=script&lang=ts"

export default script